<template>
<!-- Site wrapper -->
  <div class="form-row">
    <div class="form-group col-md-12 col-lg-6 col-xl-6">
      <label for="inputTipoCorrespondente" class="required">Tipo Correspondente</label>
      <v-select
        class="style-chooser"
        v-model="dadosPerfil.f_type"
        :options="comboTiposCorrespondentesDisponiveis"
        :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
        :filterable="true">
        <template v-slot:no-options>
          <em>Nenhum registro encontrado.</em>
        </template>
      </v-select>
      <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_profile_data.f_type']}}</div>
    </div>
    <div class="w-100 d-none d-md-block"></div>
    <div class="form-group col-md-6 col-lg-6 col-xl-5">
      <label for="inputEstado" class="required">Estado</label>
      <v-select
        class="style-chooser"
        v-model="estadoSelecionado"
        @search="eventoDigitarBuscaPorEstado"
        @input="eventoBuscarComarcasPeloEstado"
        :options="comboEstadosDisponiveis"
        :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
        :filterable="false">
        <template v-slot:no-options>
          <em>Nenhum registro encontrado.</em>
        </template>
      </v-select>
      <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_state']}}</div>
    </div>
    <div class="form-group col-md-6 col-lg-6 col-xl-5">
      <label for="inputComarca" class="required">Comarca</label>
      <v-select
        class="style-chooser"
        v-model="comarcaSelecionada"
        @search="eventoDigitarBuscaPorComarca"
        :options="comboComarcasDisponiveis"
        :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
        :filterable="false">
        <template v-slot:no-options>
          <em>Nenhum registro encontrado.</em>
        </template>
      </v-select>
      <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_district']}}</div>
    </div>
    <div class="form-group text-right col-md-12 col-lg-12 col-xl-2">
      <b-button class="botoes" style="margin-top: 2.1rem;" variant="outline-primary btn-sm" @click="vincularComarca()" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">Adicionar</b-button>
    </div>
    <div class="form-group col-md-12 col-lg-12 col-xl-11">
      <b-form-group label="Comarca" label-for="comarcaFiltro" label-align-sm="left" label-size="sm" class="mb-0"></b-form-group>
      <b-form-input id="comarca" v-model="camposFiltroPesquisa.comarca" type="text" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"></b-form-input>
    </div>
    <div class="form-group text-right col-md-12 col-lg-12 col-xl-1">
      <b-button class="botoes" style="margin-top: 3.3rem;" variant="outline-primary btn-sm" @click="buscarRegistros()" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">Buscar</b-button>
    </div>
    <div class="col-12">
    <default-table
      :items="listaEstadoComarcaVinculado"
      :fields="fieldsEstadoComarca"
      :busy="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
      :tbody-tr-class="tabelaSemRegistros">
      <template #empty>
        <em>Nenhum registro encontrado.</em>
      </template>
      <template #cell(opcoes)="row">
        <b-button class="botoes" variant="outline-danger btn-sm" title="Excluir" @click="desvincularComarca(row.item)" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
          <i class="fas fa-trash-alt"></i>
        </b-button>
      </template>
    </default-table>
    <pagination v-show="componentePaginacao.totalRegistros > 0" :fonteDeDados="componentePaginacao.fonteDeDados" :disabled="flagsDeControle.carregandoDados.status" @navegarNaPaginacao="obterDadosPaginados"/>
    </div>
  </div>
</template>

<script>
import Correspondente from '../layoutPerfil/js/correspondente'
export default Correspondente
</script>

<style scoped>
@import "../layoutPerfil/scss/correspondente.scss";
</style>
